const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

export const isEditableTarget = (target) =>
  Boolean(target) && (EDITABLE_TAGS.includes(target.tagName) || target.isContentEditable);
